export const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
